import { useEffect, useState } from "react";

const S = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

export const BASES = {
  slate: { label: "Gece Laciverti", v: ["248 250 252", "241 245 249", "226 232 240", "203 213 225", "148 163 184", "100 116 139", "71 85 105", "51 65 85", "30 41 59", "15 23 42", "2 6 23"] },
  navy: { label: "Derin Okyanus", v: ["240 246 255", "226 236 252", "204 220 245", "170 192 230", "130 155 200", "90 115 160", "62 84 128", "40 60 104", "22 40 80", "11 26 58", "4 12 34"] },
  zinc: { label: "Grafit", v: ["250 250 250", "244 244 245", "228 228 231", "212 212 216", "161 161 170", "113 113 122", "82 82 91", "63 63 70", "39 39 42", "24 24 27", "9 9 11"] },
  neutral: { label: "Gece Siyahı", v: ["250 250 250", "245 245 245", "229 229 229", "212 212 212", "163 163 163", "115 115 115", "82 82 82", "64 64 64", "38 38 38", "23 23 23", "10 10 10"] },
  stone: { label: "Sıcak Taş", v: ["250 250 249", "245 245 244", "231 229 228", "214 211 209", "168 162 158", "120 113 108", "87 83 78", "68 64 60", "41 37 36", "28 25 23", "12 10 9"] },
  forest: { label: "Orman", v: ["240 250 246", "228 244 238", "205 230 220", "170 205 192", "125 165 150", "85 125 110", "58 92 80", "38 68 58", "20 46 40", "10 30 26", "3 15 13"] },
};

export const ACCENTS = {
  blue: { label: "Mavi", v: ["239 246 255", "219 234 254", "191 219 254", "147 197 253", "96 165 250", "59 130 246", "37 99 235", "29 78 216", "30 64 175", "30 58 138", "23 37 84"] },
  indigo: { label: "Çivit", v: ["238 242 255", "224 231 255", "199 210 254", "165 180 252", "129 140 248", "99 102 241", "79 70 229", "67 56 202", "55 48 163", "49 46 129", "30 27 75"] },
  violet: { label: "Mor", v: ["245 243 255", "237 233 254", "221 214 254", "196 181 253", "167 139 250", "139 92 246", "124 58 237", "109 40 217", "91 33 182", "76 29 149", "46 16 101"] },
  emerald: { label: "Zümrüt", v: ["236 253 245", "209 250 229", "167 243 208", "110 231 183", "52 211 153", "16 185 129", "5 150 105", "4 120 87", "6 95 70", "6 78 59", "2 44 34"] },
  cyan: { label: "Turkuaz", v: ["236 254 255", "207 250 254", "165 243 252", "103 232 249", "34 211 238", "6 182 212", "8 145 178", "14 116 144", "21 94 117", "22 78 99", "8 51 68"] },
  rose: { label: "Kırmızı", v: ["255 241 242", "255 228 230", "254 205 211", "253 164 175", "251 113 133", "244 63 94", "225 29 72", "190 18 60", "159 18 57", "136 19 55", "76 5 25"] },
  orange: { label: "Turuncu", v: ["255 247 237", "255 237 213", "254 215 170", "253 186 116", "251 146 60", "249 115 22", "234 88 12", "194 65 12", "154 52 18", "124 45 18", "67 20 7"] },
};

export const swatch = (pal, shade) => `rgb(${pal.v[S.indexOf(shade)]})`;

// light mode: base scale is mirrored; light accent shades (used as text) are darkened
const LIGHT_ACC = [9, 8, 7, 7, 6, 5, 6, 7, 2, 1, 0];

export function getMode() {
  try {
    const m = localStorage.getItem("karahan_mode");
    if (m === "light" || m === "dark") return m;
  } catch {}
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function applyTheme(t) {
  const base = BASES[t?.base] || BASES.slate;
  const acc = ACCENTS[t?.accent] || ACCENTS.blue;
  const light = getMode() === "light";
  const root = document.documentElement;
  const st = root.style;
  S.forEach((k, i) => {
    st.setProperty(`--d-slate-${k}`, base.v[i]);
    st.setProperty(`--d-blue-${k}`, acc.v[i]);
    st.setProperty(`--c-slate-${k}`, light ? base.v[10 - i] : base.v[i]);
    st.setProperty(`--c-blue-${k}`, light ? acc.v[LIGHT_ACC[i]] : acc.v[i]);
  });
  root.classList.toggle("light", light);
  root.classList.toggle("dark", !light);
  try { localStorage.setItem("karahan_theme", JSON.stringify(t || {})); } catch {}
}

export function applyCachedTheme() {
  try { applyTheme(JSON.parse(localStorage.getItem("karahan_theme") || "{}")); } catch { applyTheme({}); }
}

export function setMode(m) {
  try { localStorage.setItem("karahan_mode", m); } catch {}
  applyCachedTheme();
  window.dispatchEvent(new Event("karahan-mode"));
}

export function useMode() {
  const [m, setM] = useState(getMode);
  useEffect(() => {
    const f = () => setM(getMode());
    window.addEventListener("karahan-mode", f);
    return () => window.removeEventListener("karahan-mode", f);
  }, []);
  return m;
}
